/** Client-side Payslip PDF via jsPDF */
import { jsPDF } from 'jspdf';

const COMPANY = { name: 'Hipro Technologies', tagline: 'Software · AI · Growth', email: 'info@hiprotechnologies.com' };

const fmt = (n) => (Number(n) || 0).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 });

export const generatePayslipPdf = (p) => {
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const W = doc.internal.pageSize.getWidth();
  const M = 40;

  // Header
  doc.setFillColor(15, 23, 42);
  doc.rect(0, 0, W, 84, 'F');
  doc.setTextColor(255, 255, 255); doc.setFont('helvetica', 'bold'); doc.setFontSize(20);
  doc.text(COMPANY.name, M, 40);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
  doc.text('Payslip · Confidential', M, 58);
  doc.setFontSize(9); doc.setTextColor(200, 210, 230);
  doc.text(`Payslip ID: ${p.payslip_id}`, W - M, 40, { align: 'right' });
  doc.text(`Month: ${p.month}`, W - M, 56, { align: 'right' });

  doc.setTextColor(15, 23, 42); doc.setFont('helvetica', 'bold'); doc.setFontSize(16);
  doc.text('Salary Slip', M, 118);

  // Employee details
  const info = [
    ['Employee', `${p.employee_name} (${p.employee_id})`],
    ['Designation', p.designation || '—'],
    ['Department', p.department || '—'],
    ['Total days', String(p.total_days)],
    ['Paid days', String(p.paid_days)],
    ['Unpaid days', String(p.unpaid_days)],
  ];
  let y = 140;
  info.forEach(([k, v], i) => {
    const col = i % 2, row = Math.floor(i / 2);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor(100, 116, 139);
    doc.text(k, M + col * 260, y + row * 18);
    doc.setFont('helvetica', 'bold'); doc.setTextColor(15, 23, 42);
    doc.text(String(v), M + col * 260 + 110, y + row * 18);
  });
  y += 3 * 18 + 12;

  // Earnings & Deductions two-column table
  doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor(15, 23, 42);
  doc.text('Earnings', M, y);
  doc.text('Deductions', M + 300, y);
  y += 8;
  doc.setDrawColor(226, 232, 240);
  doc.line(M, y, W - M, y);
  y += 14;
  const eRows = [
    ['Basic', p.earnings?.basic],
    ['HRA', p.earnings?.hra],
    ['Special allowance', p.earnings?.special_allowance],
  ];
  const dRows = [
    ['Income tax', p.deductions?.tax],
    ['Provident fund (PF)', p.deductions?.pf],
  ];
  doc.setFont('helvetica', 'normal'); doc.setFontSize(10);
  const maxRows = Math.max(eRows.length, dRows.length);
  for (let i = 0; i < maxRows; i++) {
    const e = eRows[i], d = dRows[i];
    if (e) { doc.setTextColor(51, 65, 85); doc.text(e[0], M, y); doc.setTextColor(15, 23, 42); doc.text(fmt(e[1]), M + 200, y, { align: 'right' }); }
    if (d) { doc.setTextColor(51, 65, 85); doc.text(d[0], M + 300, y); doc.setTextColor(15, 23, 42); doc.text(fmt(d[1]), M + 500, y, { align: 'right' }); }
    y += 16;
  }
  y += 6;
  doc.line(M, y, W - M, y); y += 16;
  doc.setFont('helvetica', 'bold');
  doc.text('Gross earnings', M, y); doc.text(fmt(p.gross), M + 200, y, { align: 'right' });
  const totDed = (p.deductions?.tax || 0) + (p.deductions?.pf || 0);
  doc.text('Total deductions', M + 300, y); doc.text(fmt(totDed), M + 500, y, { align: 'right' });
  y += 22;

  // Net pay panel
  doc.setFillColor(240, 253, 244);
  doc.setDrawColor(190, 231, 200);
  doc.roundedRect(M, y, W - M * 2, 60, 8, 8, 'FD');
  doc.setFont('helvetica', 'bold'); doc.setFontSize(12); doc.setTextColor(4, 120, 87);
  doc.text('Net pay', M + 20, y + 26);
  doc.setFontSize(22); doc.text(fmt(p.net), W - M - 20, y + 34, { align: 'right' });

  y += 88;
  doc.setFont('helvetica', 'normal'); doc.setFontSize(8); doc.setTextColor(100, 116, 139);
  doc.text('This is a system-generated payslip. For queries contact People Team at ' + COMPANY.email + '.', M, y);

  doc.save(`Payslip-${p.employee_id}-${p.month}.pdf`);
};
